import { Injectable }          from '@angular/core';
import * as firebase from 'firebase';



import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { CompanyService, AppDataService } from './services';

@Injectable()
export class MessagingService {



  currentMessage = new BehaviorSubject(null)

  constructor(private _companyService: CompanyService ,private _appData: AppDataService) {
    var config = {
      apiKey: "AIzaSyBt_xy2toHw8Z31ItiZgPUnahcaHERfSr8",
      authDomain: "coolkids-669fa.firebaseapp.com",
      databaseURL: "https://coolkids-669fa.firebaseio.com",
      projectId: "coolkids-669fa",
      storageBucket: "coolkids-669fa.appspot.com",
      messagingSenderId: "159459566585"
    };
    try {
      firebase.initializeApp(config);
    }
    catch (err){
      //already connected
    }
   }


  updateToken(token) {
      this._companyService.updateGCMToken(token).subscribe();
  }

  getPermission() {
    try{
      let  messaging = firebase.messaging()

      messaging.requestPermission()
      .then(() => {
        console.log('Notification permission granted.');
        return messaging.getToken()
      })
      .then(token => {
        console.log(token)
        this.updateToken(token)
      })
      .catch((err) => {
        console.log('Unable to get permission to notify.', err);
      });
    } catch (err){}
  }

    receiveMessage() {
      try{
        let  messaging = firebase.messaging()
        messaging.onMessage((payload) => {
          console.log('normal message received ', payload);
          this.currentMessage.next(payload)
        }); 
        messaging.setBackgroundMessageHandler((payload) => {
          console.log('[firebase-messaging-sw.js] Received background message ', payload);
        });
        
        
      }
      catch(err){}

    }
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/messaging.service.ts